import { render, staticRenderFns } from "./UserAnalysis.vue?vue&type=template&id=e0c70e06&"
import script from "./UserAnalysis.vue?vue&type=script&lang=js&"
export * from "./UserAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./UserAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports